// Extracted from the `list.reachOut` namespace of en.ts so the (over-length) main translation file
// stays within the architecture-gate line ratchet. Spread back in as `list.reachOut` in en.ts.
export const enReachOut = {
	button: "Reach out",
	review: "Review",
	reply: "Reply",
	aiDrafts: "AI drafts",
	aiSnippets: "AI Snippets",
	menuHeading: "Reach out to {{name}}",
	menuHeadingBulk_one: "Reach out to {{count}} lead",
	menuHeadingBulk_other: "Reach out to {{count}} leads",
	addToCampaign: {
		title: "Add to campaign",
		description: "Add to campaigns or create AI Snippets first to review them.",
		lockedDescription: "No campaign in this list yet",
		lockedPopover:
			"You can only add leads to a campaign once this list has one. Create a campaign to get started.",
	},
	reviewCampaign: {
		title: "Review & edit campaign",
		description:
			"Review {{name}} and decide which campaign to add to and edit the campaign if necessary.",
		descriptionBulk:
			"Review the selected leads and decide which campaign to add to and edit the campaign if necessary.",
		lockedPopover:
			"You can only review and edit a campaign once this list has one. Create a campaign to get started.",
	},
	letAiWrite: {
		title: "Let AI write a sequence",
		description: "Tell AI what to write, review and send out.",
	},
	writeManually: {
		title: "Write manually",
		description: "Use templates and snippets and schedule follow ups.",
		lockedDescriptionBulk: "Available per lead — open a single lead to compose.",
	},
	runAiSnippets: {
		title: "Run AI Snippets",
		description: "Generate the AI snippets your campaign uses for the selected leads.",
	},
	revertCampaign: {
		title: "Revert Assigned Campaign",
		description: "Remove the selected leads from their assigned campaign.",
	},
	createCampaign: "Create a campaign",
	picker: {
		searchPlaceholder: "Search campaigns…",
		selectedLabel: "Selected campaign",
		changeSenders: "Change the senders of the campaign",
		createSnippets: "Create AI snippets",
		addAndSend: "Add to campaign & send out",
		assignToCampaign: "Assign to campaign",
		clear: "Clear selection",
		aiSnippetsBadge: "AI snippets",
		noResults: "No campaigns match your search",
		noLeadsAssigned: "No leads assigned yet",
		assignedCount: "{{count}} assigned",
		contactedStat: "{{contacted}}/{{total}} contacted ({{pct}}%)",
		setupIncomplete: "Setup incomplete",
		needsRefresh: "Setup looks complete — open the campaign once so it can refresh its status.",
		invalidSince: "Cannot run since {{date}}",
		openToFix: "Open campaign",
	},
	/**
	 * PREC-4426: leads already connected on LinkedIn, before they are added. Describes the invite
	 * step's "Stop the campaign for leads who are already connected" (api `stopLeadAlreadyConnected`):
	 * change the wording when that behaviour changes.
	 */
	alreadyConnected: {
		title: "Already connected on LinkedIn",
		singleStops:
			'{{lead}} is already connected to {{senders}}, this campaign\'s sender. The campaign has a "Send LinkedIn Invite" step, so it will stop for this lead there and the lead will show in Outbox → Error.',
		singleSkips:
			'{{lead}} is already connected to {{senders}}, this campaign\'s sender. Its "Send LinkedIn Invite" step will skip the invite and continue with the next step.',
		bulkTitle: "{{count}} of {{total}} leads are already connected on LinkedIn",
		bulkStops:
			'to this campaign\'s sender. The campaign will stop for them at "Send LinkedIn Invite".',
		bulkSkips:
			'to this campaign\'s sender. "Send LinkedIn Invite" will skip the invite for them and continue with the next step.',
		showLeads: "Show the {{count}} leads",
		hideLeads: "Hide the leads",
		skip: "Don't add the {{count}} connected leads",
		colleagueHint:
			"{{lead}} is connected to your colleague {{colleagues}} on LinkedIn, not to this campaign's sender.",
		checkFailed: "Could not check whether these leads are already connected on LinkedIn.",
		addCountAndSend: "Add {{count}} to campaign & send out",
		assignCount: "Assign {{count}} to campaign",
		unnamedLead: "This lead",
	},
	toast: {
		assigned: 'Added {{name}} to "{{campaign}}" — sending',
		assignedBulk: 'Added {{count}} leads to "{{campaign}}" — sending',
		assignedBulkSkipped:
			'Added {{count}} leads to "{{campaign}}" — sending. Left out {{skipped}} already connected on LinkedIn.',
		snippets: 'Generating AI snippets for "{{campaign}}"…',
		generating: "Generating drafts for {{name}}…",
		generatingBulk: "Generating sequences for {{count}} leads…",
	},
};
